import { t } from '@/features/i18n/utils';
import { Logo } from '@/ui/components/logo';
import { Button } from '@/ui/components/button';
import { createFileRoute, Link } from '@tanstack/react-router';
import { z } from 'zod';

const REASON_TEXT = {
  inactivity: {
    en: 'You were signed out after a period of inactivity.',
    nb: 'Du ble logget ut etter en periode uten aktivitet.',
  },
  accessRevoked: {
    en: 'Your access has been revoked or your account was disabled. Contact your administrator if you believe this is a mistake.',
    nb: 'Tilgangen din er trukket tilbake eller kontoen din er deaktivert. Kontakt administratoren din hvis du mener dette er feil.',
  },
  invitationExpired: {
    en: 'Your invitation has expired. Ask your administrator to resend it, then sign in again.',
    nb: 'Invitasjonen din har utløpt. Be administratoren din om å sende den på nytt, og logg inn igjen.',
  },
  sessionExpired: {
    en: 'Your session could not be renewed. It may have expired or your access may have changed. Sign in again to continue.',
    nb: 'Økten kunne ikke fornyes. Den kan ha utløpt, eller tilgangen din kan ha blitt endret. Logg inn på nytt for å fortsette.',
  },
  generic: { en: 'You have been signed out.', nb: 'Du er logget ut.' },
};

export const Route = createFileRoute('/_auth/session-ended')({
  component: RouteComponent,
  validateSearch: z.object({
    reason: z
      .enum(['inactivity', 'accessRevoked', 'invitationExpired', 'sessionExpired'])
      .optional(),
    target: z.string().optional(),
  }),
});

function RouteComponent() {
  const { reason, target } = Route.useSearch();

  return (
    <div className="px-5 -translate-y-5 w-full flex flex-col items-center">
      <Logo className="mb-5 mx-auto" />
      <h1 className="text-center font-medium text-lg mb-1">
        {t({ en: 'Your session has ended', nb: 'Økten din er avsluttet' })}
      </h1>
      <p className="mb-4 text-center text-muted max-w-md">{t(REASON_TEXT[reason ?? 'generic'])}</p>
      <Button
        nativeButton={false}
        variant="secondary"
        render={<Link to="/login" search={{ target }} />}
      >
        {t({ en: 'Sign in again', nb: 'Logg inn på nytt' })}
      </Button>
    </div>
  );
}
